import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Checkbox from 'material-ui/Checkbox';
import Typography from 'material-ui/Typography';
import ArrowToolTip from '../../common/ArrowToolTip';
import HelpIcon from '../../Icons/HelpIcon';
import { DAILY_NOTIFICATION_FILTER_CONFIG } from '../../../constants/ExecutiveListSearchKeyConstants';

const styles = () => ({
  root: {
    width: '100%',
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },
  text: {
    marginLeft: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },
  arrowClass: {
    position: "absolute",
    fontSize: 6,
    bottom: 0,
    left: "calc(34% - 1.5em)",
    marginBottom: "-0.95em",
    width: "3em",
    height: "1em",

    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "1em 1em 0 1em",
      borderColor: `#181819 transparent transparent transparent`,
    },
  }
});

const propertyKeys = Object.keys(DAILY_NOTIFICATION_FILTER_CONFIG);

class DailyNotificationControl extends React.Component {
  handleUpdateKeymanCheck = (property) => () => {
    const config = DAILY_NOTIFICATION_FILTER_CONFIG[property];
    if (config) {
      const currentValue = this.props.value;
      const newValue = currentValue ? '' : config.label;
      this.props.onChange(property, newValue);
    }
  }

  render() {
    const { classes, property, value, disabled } = this.props;
    const config = DAILY_NOTIFICATION_FILTER_CONFIG[property];
    const message = config ? '本日' + config.label : '';

    return (
      <div className={classes.root} onClick={this.handleUpdateKeymanCheck(property)}>
        <Checkbox
          color="primary"
          checked={!!value}
          onChange={this.handleUpdateKeymanCheck(property)}
          style={{
            width: '20px',
            height: '20px',
          }}
          disabled={disabled}
        />
        <Typography
          variant="subheading"
          className={classes.text}
          style={{ color: disabled ? '#B1B3B9' : '#181819' }}
        >
          {message}
        </Typography>
        {config.description && (
          <ArrowToolTip
            text={config.description}
            arrowClass={classes.arrowClass}
            style={{ marginLeft: '2px' }}
          >
            <HelpIcon
              width={16}
              height={16}
              color="#71737B"
            />
          </ArrowToolTip>
        )}
      </div>
    );
  }
}

DailyNotificationControl.propTypes = {
  classes: PropTypes.object.isRequired,
  property: PropTypes.oneOf(propertyKeys).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(DailyNotificationControl);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/DailyNotificationControl.jsx